import {action, thunk, Action, Thunk} from 'easy-peasy';
import axios from 'axios';

interface Rule {
    id: number;
    [key: string]: any;
}

interface RuleStore {
    items: Rule[];
    loading: boolean;
    setLoading: Action<RuleStore, boolean>;
    loadRules: Action<RuleStore, Rule[]>;
    addOrEditRule: Action<RuleStore, Rule>;
    deleteRule: Action<RuleStore, number>;
    changePosition: Action<RuleStore, [number, number]>;
    commitReorder: Thunk<RuleStore, number>;
}

export default {
    items: [] as Rule[],
    loading: false,
    setLoading: action((state: any, loading: boolean) => {
        state.loading = loading;
    }),
    loadRules: action((state: any, rulesList: Rule[]) => {
        state.items = rulesList;
    }),
    addOrEditRule: action((state: any, rule: Rule) => {
        const existingIndex = state.items.findIndex((r: any) => r.id === rule.id);

        if (existingIndex !== -1) {
            state.items.splice(existingIndex, 1, rule);
        } else {
            state.items.push(rule);
        }
    }),
    deleteRule: action((state: any, ruleId: number) => {
        const index = state.items.findIndex((r: any) => r.id === ruleId);

        state.items.splice(index, 1);
    }),
    changePosition: action((state: any, [dragIndex, hoverIndex]: [number, number]) => {
        const draggingRule = state.items[dragIndex];

        state.items.splice(dragIndex, 1);
        state.items.splice(hoverIndex, 0, draggingRule);
    }),
    commitReorder: thunk(async (actions, activeChannelId: number, {getState}: any) => {
        await axios.post(window.URLS.rulesReorderResource, {
            sortingOrder: getState().items.map((obj: any, idx: number) => ({
                id: obj.id,
                sortIndex: idx,
            })),
            channelId: activeChannelId,
        });
    }),
} as unknown as RuleStore;
